import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { editNetworkElement } from '@api/networkElements';

import { INetworkElementDTO } from '@interfaces/networkElements/dto/networkElements';
import { INetworkElement } from '@interfaces/networkElements/networkElements';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENTS_EDIT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateNetworkElements from './useInvalidateNetworkElements';

interface IUseMutateNetworkElementsCreateReturned {
	editNetworkElement: (dto: INetworkElementDTO) => void;
	isLoadingEditNetworkElement: boolean;
}

const useMutateNetworkElementsEdit = (handleCloseModal: () => void): IUseMutateNetworkElementsCreateReturned => {
	const dispatch = useAppDispatch();
	const invalidateNetworkElements = useInvalidateNetworkElements();

	const {
		isLoading,
		mutate,
	} = useMutation<INetworkElementDTO>({
		mutationKey: [NETWORK_ELEMENTS_EDIT],
		mutationFn: editNetworkElement,
		onSuccess: (data: INetworkElement) => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.networkElementUpdated(data.name),
				type: ESnackbarTypes.success,
			}));

			return invalidateNetworkElements();
		},
	});

	return {
		editNetworkElement: mutate,
		isLoadingEditNetworkElement: isLoading,
	};
};

export default useMutateNetworkElementsEdit;
